import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=6a1012e8&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=6a1012e8&prod&scoped=true&lang=scss"
import style1 from "./ProductForm.vue?vue&type=style&index=1&id=6a1012e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1012e8",
  null
  
)

export default component.exports